import React, { Component } from 'react';
import { MdErrorOutline } from 'react-icons/md';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary:', error, errorInfo);
  }

  handleRefresh() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='flex flex-col items-center justify-center p-8 rounded-lg bg-red-50 border border-red-200 max-w-md mx-auto my-8 shadow-sm'>
          <div className='flex items-center justify-center mb-4'>
            <MdErrorOutline className='text-red-500 w-8 h-8' />
          </div>
          <h2 className='text-xl font-semibold text-red-700 mb-2'>
            Something went wrong!
          </h2>
          <p className='text-red-600 text-center mb-4'>
            We're sorry, but we encountered an error.
          </p>
          <button
            className='px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors duration-300 font-medium'
            onClick={this.handleRefresh}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
